module.exports = __webpack_public_path__ + "assets/img/ic-filter.3bbbb299.svg";